<script setup>
import { useStore } from 'vuex'
import { extractAllUrlParamsAndSetThemInVuexStore, pingOnPageLoadWithData } from "@/js/utils";
import { computed, onBeforeMount, onMounted } from 'vue'

import ProgressV2 from '@/components/Paths/SharedComponents/ProgressV2.vue'
import WorkingWithAttorney from '@/components/Paths/PreSettlementFunding/Steps/WorkingWithAttorney.vue'
import ReceivedFunding from '@/components/Paths/PreSettlementFunding/Steps/ReceivedFunding.vue'
import LawFirmInformation from '@/components/Paths/PreSettlementFunding/Steps/LawFirmInformation.vue'
import UserPii from '@/components/Paths/PreSettlementFunding/Steps/UserPii.vue'

const store = useStore()
const minHeight = computed(() => store.state.minHeightOfTheLastComponent)
const currentStep = computed(() => store.state.currentStep)

const STEPS = {
  'WorkingWithAttorney': { component: WorkingWithAttorney },
  'ReceivedFunding': { component: ReceivedFunding },
  'LawFirmInformation': { component: LawFirmInformation },
  'UserPii': { component: UserPii }
}

function goToNextStep(step) {
  store.commit('SET_IS_LOADING', true)
  store.dispatch('preSettlementFunding/goToNextStep', step)
}

onBeforeMount(() => {
  pingOnPageLoadWithData()
  const oid = '238'
  store.commit('SET_EF_OID', oid)

  store.dispatch('init')
  store.state.page = window.location.pathname.replace('/', '')

  goToNextStep('StartPath')
})

onMounted(() => {
  window.loadJornayaLeadId('95d04875-f9c8-589a-4ece-147b1dc99a8c')

  store.commit('SET_ARRAY_OF_FIELDS', extractAllUrlParamsAndSetThemInVuexStore())

  document.body.classList.add('workers-comp')
  document.body.classList.add('aat-style')
})
</script>

<template>
  <div
    :style="{'min-height': minHeight + 'px'}"
    class="content-wrapper"
  >
    <transition
      name="component-fade"
      mode="out-in"
      :duration="30"
    >
      <component
        :is="STEPS[currentStep].component"
        @next-step="goToNextStep"
      >
        <slot name="progress">
          <ProgressV2 :progress="store.state.progress"/>
        </slot>
      </component>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/style/flow-style";
@use "@/assets/style/constants";
</style>